import {AbstractSyncfields} from "./AbstractSyncfields";
import {nsUserSyncfields} from "./nsUserSyncfields";
import {IRouteDefinitionParams} from "../../../index";
import ICard = nsUserSyncfields.ICard;
import positions_pageHtml from './positions-page.html?raw';

export const template = positions_pageHtml;

export class viewModel extends AbstractSyncfields {
    protected readonly def: nsUserSyncfields.ICard[] = nsUserSyncfields.def.positions ?? []

    constructor(params: IRouteDefinitionParams) {
        super(params);
    }

    private shouldShow(def: ICard): boolean {
        return nsUserSyncfields.shouldShow(def, this.object)
    }

}
